import React from 'react';
import {
 Flash
} from 'AWS-UI-Components-React';
import BONESMidwayJavaScriptClient from 'BONESMidwayJavaScriptClient';
import {getYesterdayDate, getCurrentDateAtMidnight} from "../utils/date";

export const Header = ({title, counter}) => {

  return <div className='awsui-util-action-stripe'>
    <div className='awsui-util-action-stripe-title'>
      <h2>{title}&nbsp;
        {counter ? <span className='custom-action-stripe-counter'>{counter}</span> : ''}
      </h2>
    </div>
    <div className='awsui-util-action-stripe-group'>
    </div>
  </div>
};

export const FlashMessage = () => (
  <Flash
    type='success'
    content='Resource created successfully'
    dismissible={true}
  ></Flash>
);

export class JSClient {

    constructor(props){
        this.props = props || {};
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getBeers = this.getBeers.bind(this);
        this.getTasks = this.getTasks.bind(this);
        this.getBeer = this.getBeer.bind(this);
        this.getIdentity = this.getIdentity.bind(this);
        this.postBeer = this.postBeer.bind(this);
        this.getApprovals = this.getApprovals.bind(this);
        new BONESMidwayJavaScriptClient({onReady : this.clientLoaded});
    }

    clientLoaded(client){
        this.client = client;
        if (this.props.hasOwnProperty("onReady")){
            this.props.onReady();
        }
    }

    postBeer(callback, errorCallback, beerName, description) {
      this.client.post(`beers`, {
        name: beerName,
        description: description
      }).then( function(response){
          callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
          errorCallback(error);
        }
      });
  }

    getIdentity(callback, errorCallback){
        this.client.get(`identity`)
        .then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    getBeers(callback, errorCallback) {
        this.client.get(`beers`).then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    getTasks(data, callback, errorCallback) {
        const {date}=data;
        const uri={
            "recent" : `tasks?user=${data.user}&limit=10`,
            "yesterday" : `tasks?user=${data.user}&startDate=${getYesterdayDate()}&endDate=${getCurrentDateAtMidnight()}`,
            "custom" : date?`tasks?user=${data.user}&startDate=${new Date(date.start).getTime()}&endDate=${new Date(date.end).setHours(24,60,60,1000)}`:null
        }

        this.client.get(uri[data.type]).then( function(response){
            callback(response.data);
        }).catch(function (error) {
            console.log(error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    getSearches(data, callback, errorCallback) {
        this.client.get(`searches?user=${data.user}`).then( function(response){
            callback(response.data);
        }).catch(function (error) {
            console.log(error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    getReports(data, callback, errorCallback) {
        console.log("asasasss");
        this.client.get(`reports?searchId=${data.searchId}`).then( function(response){
            callback(response.data);
        }).catch(function (error) {
            console.log(error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    getApprovals(data, callback, errorCallback) {
        let uri ="approvals?";
        if (data.invoiceId)
            uri+=`invoiceId=${data.invoiceId}`;
        if (data.source)
            uri+=`&source=${data.source}`;
        // uri = "approvals?invoiceId=66453606444"
        this.client.get(uri).then( function(response){
            callback(response.data);
        }).catch(function (error) {
            console.log(error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    getFOCInvoices(data, callback, errorCallback) {
        let uri ="focinvoices?invoiceNumber="+data.invoiceNumber;
        // if (data.invoiceId)
        //     uri+=`invoiceId=${data.invoiceId}`;
        // if (data.source)
        //     uri+=`&source=${data.source}`;
        // // uri = "approvals?invoiceId=66453606444"
        this.client.get(uri).then( function(response){
            callback(response.data);
        }).catch(function (error) {
            console.log(error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    getBeer(id, callback, errorCallback) {
      this.client.get(`beers/${id}`).then( function(response){
          callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
          errorCallback(error);
        }
      });
    }
};


// WEBPACK FOOTER //
// ./src/components/common.jsx